import { selectMentionData } from "app/components/ReplyComment/redux/selectors";
import { replyCommentSliceActions } from "app/components/ReplyComment/redux/slice";
import { UIEvent, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

export const useMentionDropdown = (searchQuery: string, projectId: string) => {
  // Hooks
  const dispatch = useDispatch();
  const mentionData = useSelector(selectMentionData);
  const ticketData = mentionData[projectId]?.tickets;
  const memberData = mentionData[projectId]?.members;
  const ticketPagination = mentionData[projectId]?.tickets?.pagination;
  const ticketHasMore = Boolean(
    ticketPagination && ticketPagination.page < ticketPagination.totalPage,
  );

  const normalizedQuery = searchQuery.toLowerCase();

  const filteredMembers = useMemo(
    () =>
      memberData?.list?.filter((member) =>
        member?.name?.toLowerCase().includes(normalizedQuery),
      ),
    [normalizedQuery, memberData?.list],
  );

  const handleTicketScroll = useCallback(
    (event: UIEvent<HTMLDivElement>) => {
      if (!projectId || ticketData?.loading || !ticketHasMore) return;

      const target = event.currentTarget;
      const remainingScroll =
        target.scrollHeight - target.scrollTop - target.clientHeight;

      if (remainingScroll > 24) return;

      dispatch(
        replyCommentSliceActions.setMentionTicketPagination({
          projectId,
          pagination: {
            ...ticketPagination,
            page: ticketPagination.page + 1,
          },
        }),
      );
      dispatch(
        replyCommentSliceActions.fetchTicketsRequest({
          projectId: projectId,
          query: searchQuery,
        }),
      );
    },
    [
      dispatch,
      projectId,
      ticketHasMore,
      ticketData?.loading,
      ticketPagination,
      searchQuery,
    ],
  );

  return {
    filteredMembers,
    handleTicketScroll,
    ticketLoading: ticketData?.loading,
    memberLoading: memberData?.loading,
  };
};
